import { IApplicationState } from '../../types/redux';

/**
 * Выбирает состояние загрузки списка статей
 */
export const selectArticleListStatus = ({ articleList }: IApplicationState) => articleList.status;
